/**
 * Which runs a task belongs to.
 *
 * `origin_run_id` alone was never the right key once a task could be resumed:
 * a task created in run A and continued in run B is filtered out of run B's
 * message while its new run-B rows have no task to sit under, so resumed work
 * rendered as orphaned steps under one message and nothing at all under the
 * other. `touched_run_ids` is every run authorised to work on the task, so the
 * task renders under each message that actually did some of the work.
 *
 * Falls back to the origin run so a snapshot from a server that predates the
 * field behaves exactly as it did.
 */

export function taskRuns(task) {
  const touched = Array.isArray(task?.touched_run_ids)
    ? task.touched_run_ids.filter(Boolean)
    : []
  if (touched.length) return touched
  return task?.origin_run_id ? [task.origin_run_id] : []
}

// A task with no run at all stays visible: it is unscoped, not foreign.
export function taskInRun(runId, task) {
  const runs = taskRuns(task)
  return !runId || !runs.length || runs.includes(runId)
}

/**
 * A row belongs to one run only — `sequence` restarts each run — so unlike a
 * task it is never shared. Rows with no run are live SSE arrivals that precede
 * the snapshot, and belong to the run being streamed.
 */
export function rowInRun(runId, value) {
  return !runId || !value || value === runId
}
